module.exports = __webpack_public_path__ + "img/CO.0df6f2c1.svg";